export const BandWidthTypeEnum = [
  { key: "Link Speed", value: 0 },
  { key: "Data Rate", value: 1 }
];

export const CertaintyEnum = [
  { key: "90%", value: 0 },
  { key: "99%", value: 1 },
  { key: "99.9%", value: 2 },
  { key: "99.99%", value: 3 },
  { key: "99.999%", value: 4 }
];

export const FrameSizeEnum = [
  { key: "64", value: 0 },
  { key: "128", value: 1 },
  { key: "256", value: 2 },
  { key: "512", value: 3 },
  { key: "1024", value: 4 },
  { key: "1518", value: 5 },
  { key: "10000", value: 6 },
  { key: "218", value: 7 }
];

export const DurationEnum = [
  { key: 0, value: 10 },
  { key: 1, value: 100 },
  { key: 2, value: 1000 },
  { key: 3, value: 10000 },
  { key: 4, value: 100000 }
];
